import { Injectable, OnDestroy } from '@angular/core';
import { ProductEnGbInterface } from '@app/core/interfaces/product.en-gb.interface';
import { NewModal, RequestService } from 'outshared-lib';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { PremiumImpactModal } from './premium-impact.modal';

@Injectable({
    providedIn: 'root',
})
export class PremiumImpactService implements OnDestroy {
    private subscriptions = new Subscription();

    constructor(
        private request: RequestService,
        private newModal: NewModal,
    ) {}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Function to get information after adding or changing the insurance and get the new premium
     */

    public getChanges(referenceDate: string, sequenceNumber: number = null): Observable<ProductEnGbInterface[]> {
        const details$ = this.getPurchasedProducts(referenceDate, sequenceNumber);

        const detailsSubscription = details$.subscribe(
            (products: ProductEnGbInterface[]) => {
                if (products) {
                    this.openEditCoverageModal(products);
                }
            },
        );
        this.subscriptions.add(detailsSubscription);

        return details$;
    }

    private getPurchasedProducts(referenceDate: string, sequenceNumber?: number): Observable<ProductEnGbInterface[]> {
        const payload = {
            reference_date: referenceDate,
            purchased_product: { purchased_product_sequence_number: sequenceNumber },
        };
        return this.request.post('en-gb/insurance-product/request/premium_modification-purchased_products', payload)
            .pipe(
                map(result => result.data),
                map(result => result ? result.purchased_products : []),
            );
    }

    private openEditCoverageModal(products: ProductEnGbInterface[]): void {
        const modalRef = this.newModal.open(PremiumImpactModal);

        modalRef.componentInstance.products = products;
    }
}
